import { z } from 'zod';
import { courtSchema } from './IAemter';

export const realEstateSchema = z.object({
  idRealEstate: z.number(),
  Street: z.string().nullable(),
  StreetNr: z.string().nullable(),
  StreetAditional: z.string().nullable(),
  idPostcode: z.number().nullable(),
  Latitude: z.number().nullable(),
  Longitude: z.number().nullable(),
  idCourt: z.number().nullable(),
  Court: courtSchema.optional(),
  LandRegister: z.string(),
  SheetLandRegister: z.string(),
  Parcel: z.string(),
  LandParcel: z.string(),
  idPropertyType: z.number(),
  isBuild: z.boolean(),
  hasApartment: z.boolean(),
  BuildWith: z.string().nullable(),
  Price: z.number(),
  PriceInventoryOption: z.number().nullable(),
  Manager_idPerson: z.number().nullable(),
  hasPartialArea: z.boolean(),
  isMeasured: z.boolean(),
  hasEasement: z.boolean(),
  PaymentMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  OrderMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  Area: z.number().nullable(),
  EasementText: z.string().nullable(),
  idRealEstateUseType: z.number(),
  Defect: z.string().nullable(),
  Particularities: z.string().nullable(),
  idPurchaseContract: z.number(),
  Postcode: z.string().optional(),
  City: z.string().optional(),
});

export type IRealEstate = z.infer<typeof realEstateSchema>;
